<template>
  <v-row justify="center">
    <v-dialog
		  v-model="openModal"
			persistent
			max-width="600px"
		>
      <v-card>
        <v-card-title>
          <span class="text-h5">Input Keterangan di Tujuan</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field label="TOS" autofocus required v-model="formData.tos" @keydown.enter="focusRefs('ket')"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field label="Ket" required v-model="formData.ket" @keydown.enter="createData" ref="ket"></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text :disabled="loading" tabindex="-1" @click="$emit('close-modal'); resetFormData();">
            Close
          </v-btn>
          <v-btn color="blue darken-1" :loading="loading" text @click="createData">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from 'axios'

export default {
  name: 'CreateModal',
  props: ['openModal', 'tempData'],
  data() {
    return {
      formData: {
				tos: '',
				ket: ''
      },
      loading: false
    }
  },
  watch: {
    tempData(val) {
      if (val) {
        this.formData.tos = val;
      }
    }
  },
  methods: {
    async createData() {
			this.loading = true;
			
			await axios
				.post(`keterangan-jasa-di-tujuan`, this.formData)
					.then(res => {
						this.loading = false;
						this.$emit('update-data', res.data);

            this.resetFormData();
					})
					.catch(err => {
            this.loading = false;
            
						alert(err.response.data.message);
					}); 
    },
    resetFormData() {
      this.formData.tos = '';
      this.formData.ket = '';
    },
    focusRefs(id) {
      this.$refs[id].focus();
    },
  },
}
</script>